import { render, staticRenderFns } from "./ContactWidgetV3.vue?vue&type=template&id=6c608ea7&scoped=true"
import script from "./ContactWidgetV3.vue?vue&type=script&lang=js"
export * from "./ContactWidgetV3.vue?vue&type=script&lang=js"
import style0 from "./ContactWidgetV3.vue?vue&type=style&index=0&id=6c608ea7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1c848d52c9dbe574bb8312e4e1e1d32e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c608ea7",
  null
  
)

export default component.exports